<script setup lang="ts">
import { type BadgeProps, type ButtonProps } from '#ui/types';

// PROPS
const { variant, color } = defineProps({
    label: {
        type: [String, Number],
        default: null,
    },
    color: { type: String as PropType<BadgeProps['color']>, default: 'white' },
    deleteColor: { type: String as PropType<ButtonProps['color']>, default: 'neutral' },
    size: { type: String as PropType<ButtonProps['size']>, default: undefined },
    variant: { type: String as PropType<ButtonProps['variant']>, default: undefined },
});

// EMITS
const emit = defineEmits(['delete']);

// DATA
const ui = computed(() => {
    if (variant === 'soft') {
        return { base: `bg-${color}-50 text-${color}-950` };
    }
});
</script>

<template>
    <UBadge :size="size" :color="color" :ui="ui">
        <slot>{{ label }}</slot>
        <UButton icon="lucide:x" class="ml-1 px-0 py-0 text-current" :size="size" variant="ghost" @click="emit('delete')" />
    </UBadge>
</template>
